import React, { Component } from 'react';

import './LoadingAnimation.css';

class LoadingAnimation extends Component {
  render() {
    // https://github.com/loadingio/css-spinner/
    // CC0 License
    return (
      <div className="lds-css">
        <div className="lds-default">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }
}

export default LoadingAnimation;



// WEBPACK FOOTER //
// ./src/components/apiAccess/LoadingAnimation.js